<app-event-header
    [logo]="config.eventHeaderLogo"
    [date]="config.eventHeaderDate"
    [bgImg]="config.eventHeaderBgImg"
    [bgImgHeight]="config.eventHeaderBgImgHeight"
>
</app-event-header>
<app-main-detail
    [year]="config.year"
>
</app-main-detail>
<app-event-keys
    [year]="config.year"
>
</app-event-keys>
<app-event-detail
    [year]="config.year"
    [bgImg]="config.eventDetailBgImg"
>
</app-event-detail>
<app-event-activities
    [year]="config.year"
    [activities]="config.eventActivities"
>
</app-event-activities>
